import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { activateSweetAlert, deActivateSweetAlert } from "../SweetAlert";

export const InspectionScheduleCalculations = createSlice({
  name: "Cycle",
  initialState: {
    Cycle: {
      load: false,
      data: {},
    },
  },
  reducers: {
    addCycleSuccess: (state, action) => {
      state.Cycle = action.payload;
      state.Cycle.load = false;
    },
    addCycleFail: (state, action) => {
      state.Cycle.load = action.payload.load;
    },
  },
});

export const {
  addCycleSuccess,
  addCycleFail,
} = InspectionScheduleCalculations.actions;

export default InspectionScheduleCalculations.reducer;


export const CreateCycle = createAsyncThunk(
  "users/Cycle",
  async (param: { apiParam: any, framecount: any }, thunkAPI) => {
    var Inspections = ["Daily", "Detailed", "Combined"];
    Inspections.sort();
    const permutation_array = [[] as string[]];
    for (const inspectiondata of Inspections) { 
      const copy = [...permutation_array];
      for (const prefix of copy) {
        permutation_array.push(prefix.concat(inspectiondata));
      }
    }

    permutation_array.shift();

    var inspectorList = [] as any;

    for (let i = 0; i < param.apiParam['allInspectorData'].length; i++) {
      inspectorList.push(param.apiParam['allInspectorData'][i]['inspectorType']);
    }
    var DailyWorkingHours = 0;
    var DetailedWorkingHours = 0;
    for (let i = 0; i < param.apiParam['allInspectorData'].length; i++) {
      if (param.apiParam['allInspectorData'][i]['inspectorType'] == 'Daily') {
        DailyWorkingHours += Number(param.apiParam['allInspectorData'][i]['workingHour']);
      }
      else if (param.apiParam['allInspectorData'][i]['inspectorType'] == 'Detailed') {
        DetailedWorkingHours += Number(param.apiParam['allInspectorData'][i]['workingHour']);
      }
      else if (param.apiParam['allInspectorData'][i]['inspectorType'] == 'Combined') {
        DetailedWorkingHours += Number(param.apiParam['allInspectorData'][i]['workingHour']);
      }
    }

    const WorkingDays = param.apiParam['WorkingDays'];
    const BufferDays = param.apiParam['BufferDays'];
    const NumberOfInspector = param.apiParam['NumberOfInspector'];
    const timeReqDailyInspPerRack = param.apiParam['timeReqDailyInspPerRack'];
    const timeReqDetailedInspPerRack = param.apiParam['timeReqDetailedInspPerRack'];
    const RowCount = param.apiParam['HolidaysCount'];

    var test_arr = [];

    const count: any = {};

    inspectorList.forEach((element: any) => {
      count[element] = (count[element] || 0) + 1;
    });

    test_arr = Object.keys(count);

    test_arr.sort();

    var calculations_no: any;
    var selected_Inpsections = [test_arr];


    for (var x = 0; x < permutation_array.length; x++) {
      for (var y = 0; y < selected_Inpsections.length; y++) {
        if (permutation_array[x][0] === selected_Inpsections[y][0]
          && permutation_array[x][1] === selected_Inpsections[y][1]
          && permutation_array[x][2] === selected_Inpsections[y][2]
          && permutation_array[x][3] === selected_Inpsections[y][3]
          && permutation_array[x][4] === selected_Inpsections[y][4]
        ) {
          calculations_no = x;
        }
      }
    }


    var totalWeek = 52;

    var totalWorkingDays = totalWeek * Number(WorkingDays);
    var numberOfWorkingDays = totalWorkingDays - Number(RowCount) - Number(BufferDays);
    var totalNoOfBaysInWarehouse = param.framecount;
    var CycleList: any = [];

    
    if (permutation_array[calculations_no] as any == "Daily") {
      var timeRequiredForDailyInspection = (totalNoOfBaysInWarehouse * Number(timeReqDailyInspPerRack));
      var timeRequiredForDailyInspectionInHr = (timeRequiredForDailyInspection / 60);
      if (DailyWorkingHours > timeRequiredForDailyInspectionInHr) {
        for (let i = 1; i < 1; i++) {
          CycleList.push(i + " cycle of daily inspection ");
        }
      }
      else {
        thunkAPI.dispatch(
          activateSweetAlert({
            show: true,
            type: "warning",
            title: "Warning!",
            confirmBtnText: 'Done',
            message: "Change way of inspection",
            onConfirm: () => {
              handleonConfirm()
            },
          })
        );
  
        const handleonConfirm = () => {
          thunkAPI.dispatch(deActivateSweetAlert());
        };
      }

      thunkAPI.dispatch(
        addCycleSuccess({
          CycleList,
          load: false,
        })
      );
    }
    else if (permutation_array[calculations_no] as any == "Detailed") {
      var timeRemainingToPerformDetailedInspPerYear = Math.round(DetailedWorkingHours * numberOfWorkingDays); 
      var timeReqPerformDetailedInspOneCycle = totalNoOfBaysInWarehouse * Number(timeReqDetailedInspPerRack);
      var timeReqPerformDetailedInspOneCycleInHr = timeReqPerformDetailedInspOneCycle / 60;
      var timeReqPerformDetailedInspOneCycleInDays = Math.round(timeReqPerformDetailedInspOneCycleInHr / DetailedWorkingHours);
      var cycleCount = numberOfWorkingDays / timeReqPerformDetailedInspOneCycleInDays;
        for (let i = 1; i < cycleCount; i++) {
          numberOfWorkingDays = numberOfWorkingDays - timeReqPerformDetailedInspOneCycleInDays;
          CycleList.push({ id: i, NoOfCycle: i, CycleWorkingDays: numberOfWorkingDays, CycleBufferDays: Number(BufferDays) });
        }
      thunkAPI.dispatch(
        addCycleSuccess({
          CycleList,
          load: false,
        })
      );
    }
    else if (permutation_array[calculations_no] as any == "Daily,Detailed") {
      var timeRequiredForDailyInspection = totalNoOfBaysInWarehouse * Number(timeReqDailyInspPerRack);
      var timeRequiredForDailyInspectionInHr = (timeRequiredForDailyInspection / 60);

      if (Number(DailyWorkingHours) < timeRequiredForDailyInspectionInHr) {
        thunkAPI.dispatch(
          activateSweetAlert({
            show: true,
            type: "warning",
            title: "Warning!",
            confirmBtnText: 'Done',
            message: "Change way of inspection",
            onConfirm: () => {
              handleonConfirm()
            },
          })
        );
  
        const handleonConfirm = () => {
          thunkAPI.dispatch(deActivateSweetAlert());
        };
      } else {
        var timeRemainingToPerformDetailedInspPerYear = Number(DetailedWorkingHours) * numberOfWorkingDays;
  
        var timeReqPerformDetailedInspOneCycle = totalNoOfBaysInWarehouse * Number(timeReqDetailedInspPerRack);
        var timeReqPerformDetailedInspOneCycleInHr = (timeReqPerformDetailedInspOneCycle / 60);
        var timeReqPerformDetailedInspOneCycleInDays = Math.ceil(timeReqPerformDetailedInspOneCycleInHr / Number(DetailedWorkingHours));
  
        var cycleCount = Math.ceil(numberOfWorkingDays / timeReqPerformDetailedInspOneCycleInDays);
          for (let i = 1; i < cycleCount; i++) {
            numberOfWorkingDays = numberOfWorkingDays - timeReqPerformDetailedInspOneCycleInDays;
            CycleList.push({ id: i, NoOfCycle: i, CycleWorkingDays: numberOfWorkingDays, CycleBufferDays: Number(BufferDays) });
          }
        thunkAPI.dispatch(
          addCycleSuccess({
            CycleList,
            load: false,
          })
        );
      }


    }
    else if (permutation_array[calculations_no] as any == "Combined") {
      var timeRequiredForDailyInspection = (totalNoOfBaysInWarehouse * Number(timeReqDailyInspPerRack)) / Number(NumberOfInspector);
      var timeRequiredForDailyInspectionInHr = (timeRequiredForDailyInspection / 60);

      var timeRemainingToPerformDetailedInspPerDay = DetailedWorkingHours - timeRequiredForDailyInspectionInHr;
      var timeRemainingToPerformDetailedInspPerYear = Math.round(timeRemainingToPerformDetailedInspPerDay * numberOfWorkingDays);

      var timeReqPerformDetailedInspOneCycle = totalNoOfBaysInWarehouse * Number(timeReqDetailedInspPerRack);
      var timeReqPerformDetailedInspOneCycleInHr = (timeReqPerformDetailedInspOneCycle / 60) / Number(NumberOfInspector);
      var timeReqPerformDetailedInspOneCycleInDays = Math.round(timeReqPerformDetailedInspOneCycleInHr / timeRemainingToPerformDetailedInspPerDay);

      var cycleCount = numberOfWorkingDays / timeReqPerformDetailedInspOneCycleInDays;

      if (DetailedWorkingHours >= timeRequiredForDailyInspectionInHr) {
        for (let i = 1; i < cycleCount; i++) {
          numberOfWorkingDays = numberOfWorkingDays - timeReqPerformDetailedInspOneCycleInDays;
          CycleList.push(i + " cycle of detailed inspection with " + numberOfWorkingDays + "+" + BufferDays + " buffer days");

        }
      }
      else {
        alert("Change way of inspection");
      }

      thunkAPI.dispatch(
        addCycleSuccess({
          CycleList,
          load: false,
        })
      );
    }
    else {
      return 0;
    }
  });
